import { faArrowRightArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { OnboardingHighlightWrapper } from '@sorare/core/src/components/onboarding/OnboardingHighlightWrapper';
import { NBA_PLAY_COMMON_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { useLifecycle } from '@sorare/core/src/hooks/useLifecycle';
import { fantasy, glossary } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { CommonMarketStatus } from '@sorare/marketplace/src/components/commonCard/CommonMarketStatus';

const Root = styled(Horizontal).attrs({ gap: 2 })`
  z-index: 1;
  width: 100%;
  background-color: var(--c-nd-100);
  justify-content: space-between;
  border-top: 1px solid var(--c-nd-200);
  padding: var(--double-unit);
  @media ${tabletAndAbove} {
    justify-content: center;
  }
`;

export const MyCardsCommonMarket = () => {
  const navigate = useNavigate();
  const { lifecycle } = useLifecycle();

  const rootRef = useRef<HTMLDivElement>(null);

  return (
    <OnboardingHighlightWrapper
      highlightName="MyCardsCommonMarket"
      wrap={!lifecycle?.sawGalleryOnboarding}
      config={{ onClick: () => navigate(NBA_PLAY_COMMON_MARKET) }}
    >
      <Root ref={rootRef}>
        <Vertical>
          <BodyM bold>
            <FormattedMessage {...glossary.commonMarket} />
          </BodyM>
          <CommonMarketStatus />
        </Vertical>
        <Button
          size="medium"
          color="secondary"
          to={NBA_PLAY_COMMON_MARKET}
          startIcon={<FontAwesomeIcon icon={faArrowRightArrowLeft} />}
        >
          <FormattedMessage {...fantasy.swap} />
        </Button>
      </Root>
    </OnboardingHighlightWrapper>
  );
};
